import { Transition } from "@headlessui/react"
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline"
import { useState } from "react"
import { ToastItem, ToastType, useApp } from "../../AppProvider"

const defaultStyles: Record<ToastType, any> = {
  info: {
    icon: <InformationCircleIcon className="text-primary-500 h-6 w-6" aria-hidden="true" />,
  },
  error: {
    icon: <XCircleIcon className="h-6 w-6 text-red-500" aria-hidden="true" />,
  },
  warning: {
    icon: <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500" aria-hidden="true" />,
  },
  success: {
    icon: <CheckCircleIcon className="h-6 w-6 text-green-500" aria-hidden="true" />,
  },
}

export const Toast = ({ toast }: { toast: ToastItem }) => {
  const { header, body, type } = toast
  const { deleteToast } = useApp()
  const [show, setShow] = useState(true)

  return (
    <Transition
      show={show}
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0">
      <div className="notification pointer-events-auto w-full max-w-xs overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/10">
        <div className="p-3">
          <div className="flex items-start">
            {defaultStyles[type ?? "info"].icon}
            <div className="ml-3 w-0 flex-1 pt-0.5">
              <p className="text-sm font-medium text-gray-900">{header}</p>
              {body ? <p className="mt-1 text-sm text-gray-500">{body}</p> : null}
            </div>
            <div className="ml-4 flex shrink-0">
              <button
                type="button"
                className="focus:ring-primary-600 inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-offset-2 focus:outline-none"
                onClick={() => {
                  setShow(false)
                  deleteToast(toast)
                }}>
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  )
}
